// Copyright (c) 2016 Deere & Company

import './layouts-popover.scss';
import ExcelLayout, {getDefaultState as getExcelLayoutDefaultState} from '@deere/cps-it.warranty-model-factory/lib/excel-layout';
import React, {PropTypes} from 'react';
import ActionsPopoverList from '../actions-popover/actions-popover-list';
import OptionsDropDown from '../options-drop-down';
import Popover from '../../components/popover/popover';
import {getOptions} from '../excel-layout/services/get-options';

function handleExcelLayoutChange(layoutName) {

    const selectedLayout = layoutName ?
        this.excelLayouts.find(layout => layout.name === layoutName) :
        getExcelLayoutDefaultState();

    this.onLayoutChange(selectedLayout);

}

const LayoutsPopover = props => {

    const options = getOptions(props.onCreateLayout, props.onEditLayout, props.selectedLayout.name);

    const popoverTarget = (
        <span className={'export-drop-down'}> </span>
    );

    const popoverContent = (
        <div>
            <OptionsDropDown
                alwaysCallOnChange={true}
                className='excel-layouts-dropdown'
                isPlaceholderTranslated={false}
                isRequired={false}
                onChange={props::handleExcelLayoutChange}
                optionDisplayAttributes={['name']}
                optionKey='name'
                options={props.excelLayouts}
                placeholder='STANDARD_VIEW'
                selectedValue={props.selectedLayout.name}
                showPlaceholder={true}
            />
            <ActionsPopoverList
                options={options}
            />
        </div>
    );

    return (
        <div className={'export-container'}>
            <span
                className={'excel-icon'}
                onClick={props.onExport}
            > </span>
            <Popover
                additionalClass={'caret-icon'}
                content={popoverContent}
                target={popoverTarget}
            />
        </div>
    );

};

LayoutsPopover.displayName = 'LayoutsPopover';
LayoutsPopover.propTypes = {
    excelLayouts: PropTypes.arrayOf(PropTypes.instanceOf(ExcelLayout)).isRequired,
    onCreateLayout: PropTypes.func.isRequired,
    onEditLayout: PropTypes.func.isRequired,
    onExport: PropTypes.func.isRequired,
    onLayoutChange: PropTypes.func.isRequired,
    selectedLayout: PropTypes.instanceOf(ExcelLayout).isRequired
};

export default LayoutsPopover;



// WEBPACK FOOTER //
// ./src/shared/components/layouts-popover/index.js